import { render, staticRenderFns } from "./Matrix3View.vue?vue&type=template&id=1049750b&scoped=true"
import script from "./Matrix3View.vue?vue&type=script&lang=js"
export * from "./Matrix3View.vue?vue&type=script&lang=js"
import style0 from "./Matrix3View.vue?vue&type=style&index=0&id=1049750b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049750b",
  null
  
)

export default component.exports